'use client'

import { useEffect, useState } from 'react'
import Script from 'next/script'
import { GoogleAnalytics } from '@/components/GoogleAnalytics'

const CONSENT_KEY = 'cookie_consent'
const GA_MEASUREMENT_ID = 'G-HS8XV9N900'
const GOOGLE_ADS_ID = 'AW-17891894705'

export function ThirdPartyAnalytics() {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    const enableAnalytics = () => setEnabled(true)

    if (localStorage.getItem(CONSENT_KEY) === 'accepted') {
      enableAnalytics()
    }

    window.addEventListener('cookieConsentAccepted', enableAnalytics)
    return () => window.removeEventListener('cookieConsentAccepted', enableAnalytics)
  }, [])

  if (!enabled) {
    return null
  }

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            window.gtag = gtag;
            gtag('js', new Date());
            gtag('config', '${GA_MEASUREMENT_ID}', { send_page_view: false });
            gtag('config', '${GOOGLE_ADS_ID}', { send_page_view: false });
            window.dispatchEvent(new Event('googleAnalyticsReady'));
          `,
        }}
      />
      <GoogleAnalytics measurementId={GA_MEASUREMENT_ID} />
      <Script
        id="fb-pixel"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1529663688504484');
            fbq('track', 'PageView');
          `,
        }}
      />
      <Script
        id="ms-clarity"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "wx7c0l7jcz");
          `,
        }}
      />
    </>
  )
}